export enum NotificationsUrls {
  KnockBaseUrl = 'https://api.knock.app/',
  KnockUserTokenUrl = 'https://auth0.leaflink.com/knock_user_token',
}
